<template>
  <div>
    <b-badge
      v-for="(value, key) in values"
      :key="key"
      variant="info"
      class="text-left mr-2 mb-2"
    >
      <small class="d-block">{{ value.label }}</small>
      <span>
        {{ value.value }}
      </span>
    </b-badge>
  </div>
</template>

<script>
import isArray from "lodash/isArray";
import { mapActions } from "vuex";

export default {
  props: {
    filters: {
      default: null,
    },
  },
  data: () => ({
    categorias: [],
    moedas: [],
    tiposInstituicoes: [],
    avaliables_key: [
      "codigo",
      "nome",
      "concedente",
      "categoria",
      "created_start",
      "created_end",
      "update_start",
      "update_end",
      "available_start",
      "available_end",
      "proposta_ini_start",
      "proposta_ini_end",
      "proposta_fim_start",
      "proposta_fim_end",
      "natureza_juridica",
      "tipo_instrumento",
      "qualificacao_proposta",
      "valor_projeto_min",
      "valor_total_min",
      "moeda_id",
      "estado",
      "municipio",
      "ods",
      "areas",
      "proposta_indeterminada",
    ],
  }),
  computed: {
    keys() {
      return Object.keys(this.filters).filter((v) =>
        this.avaliables_key.includes(v)
      );
    },
    values() {
      const values = [];

      for (var i in this.keys) {
        const key = this.keys[i];

        var value = this.filters[key];

        if (typeof this["get_" + key] === "function") {
          value = this["get_" + key](this.filters[key]);
        } else if (this.isDate.indexOf(key) >= 0) {
          value = this.$options.filters.format_date(value);
        } else if (this.isNumber.indexOf(key) >= 0) {
          value = this.$options.filters.number_format(parseFloat(value));
        }

        values.push({
          label: key,
          value: value,
        });
      }

      return values;
    },

    isDate() {
      return [
        "created_start",
        "created_end",
        "update_start",
        "update_end",
        "available_start",
        "available_end",
        "proposta_ini_start",
        "proposta_ini_end",
        "proposta_fim_start",
        "proposta_fim_end",
        "natureza_juridica",
      ];
    },
    isNumber() {
      return ["valor_projeto_min", "valor_total_min"];
    },
  },
  methods: {
    ...mapActions("categorias", { categoriasToSelect: "ActionToSelect" }),
    ...mapActions("moedas", { moedasToSelect: "ActionToSelect" }),
    ...mapActions("tipos_instituicoes", {
      tiposInstituicoesToSelect: "ActionToSelect",
    }),

    get_estado(value) {
      return value.map((v) => v.sigla).toString();
    },

    get_municipio(value) {
      return value.map((v) => v.nome + " / " + v.estado_sigla).toString();
    },

    get_ods(value) {
      return value.map((v) => v.name).toString();
    },

    get_areas(value) {
      return value.map((v) => v.nome).toString();
    },

    get_categoria(value) {
      const resp = this.categorias.find((v) => v.value == value);
      return resp ? resp.text : "--";
    },

    get_moeda_id(value) {
      const resp = this.moedas.find((v) => v.value == value);
      return resp ? resp.text + " (" + resp.simbolo + ")" : "--";
    },

    get_natureza_juridica(value) {
      var resp = "";
      if (isArray(value)) {
        value = value.map((v) => parseInt(v));
        const nats = this.tiposInstituicoes.filter(
          (v) => value.indexOf(v.value) >= 0
        );
        resp = nats.length + " selecionados";
      } else {
        const nats = this.tiposInstituicoes.find((v) => v.value == value);
        resp = nats ? nats.text : null;
      }
      return resp;
    },
  },
  async created() {
    this.categorias = await this.categoriasToSelect();
    this.moedas = await this.moedasToSelect();
    this.tiposInstituicoes = await this.tiposInstituicoesToSelect();
  },
};
</script>
